// eslint-disable-next-line import/no-cycle
import accountRequestService from '@client/services/accountRequest';

const stateObj = {
  current: {
    tickerSymbol: '',
    companyName: '',
    companyAddress: '',
    city: '',
    stateAbbreviation: '',
    postalCode: '',
  },
};

const getters = {};

const actions = {
  set({commit}, payload = null) {
    if (payload !== null) {
      commit('SET', payload);
    }
  },
  async save({commit, rootState, rootGetters}, publicCompanyHolder) {
    let publiclyTradedCompany = null;

    // eslint-disable-next-line camelcase
    const requests = rootState.account.requests.current.map(({request_id, request_initiated_from}) =>
      accountRequestService.updateAccountRequest({
        clUserId: rootGetters['cognitoUser/userId'],
        id: request_id,
        requestInitiator: request_initiated_from,
        disclosures: {publicCompanyHolder},
      })
    );

    const [response] = await Promise.all(requests);

    if (response.disclosures) {
      publiclyTradedCompany = response.disclosures.publicCompanyHolder;
      commit('SET', publiclyTradedCompany);
    }

    return publiclyTradedCompany;
  },
};

const mutations = {
  SET(state, payload) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {disable, ...requiredDetails} = payload;

    state.current = requiredDetails;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
